module.exports = __webpack_public_path__ + "static/media/2400.6b930878.webp";